import React from "react";
import PropTypes from "prop-types";
import baselineSvg from "../../assets/images/baseline.svg";
import storeClosedSvg from "../../assets/images/store-closed.svg";
import { Checkbox } from "@sainsburys-tech/fable";

const actualsLineColor = "#3eb3d3";
const actualsLineWidth = 3;

const thresholdAlertThresholdLineColor = "#0c0c0c";
const thresholdAlertThresholdLineWidth = 2;
const thresholdAlertThresholdLineDasharray = "5,5";

const EnergyChartLegend = props => (
  <div className="cb-c-energy-chart__legend">
    <div className="cb-c-energy-chart__legend__items">
      {props.hasBaseline && (
        <div className="cb-c-energy-chart__legend__items__item">
          <img
            src={baselineSvg}
            alt="Baseline"
            className="cb-c-energy-chart__legend__items__item__figure"
            height={30}
            width={30}
          />
          <div className="cb-c-energy-chart__legend__items__item__label">
            Baseline
          </div>
        </div>
      )}
      <div className="cb-c-energy-chart__legend__items__item">
        <svg
          alt={props.actualsSeriesLabel}
          className="cb-c-energy-chart__legend__items__item__figure"
          height={30}
          width={30}
        >
          <g>
            <line
              x1="0"
              y1="15"
              x2="30"
              y2="15"
              style={{
                stroke: actualsLineColor,
                strokeWidth: actualsLineWidth
              }}
            />
          </g>
        </svg>
        <div className="cb-c-energy-chart__legend__items__item__label">
          {props.actualsSeriesLabel}
        </div>
      </div>
      {props.hasAlerts && (
        <div className="cb-c-energy-chart__legend__items__item">
          <svg
            alt="Alert"
            className="cb-c-energy-chart__legend__items__item__figure__alert"
            width={16}
            height={30}
          >
            <rect x="0" y="0" width="16" height="30" fill="#c92319" />
          </svg>
          <div className="cb-c-energy-chart__legend__items__item__label">
            Alert
          </div>
        </div>
      )}
      {(props.showLightsOverThresholdAlertThreshold ||
        props.showHvacOverThresholdAlertThreshold) && (
        <div className="cb-c-energy-chart__legend__items__item">
          <svg
            alt="Overnight threshold"
            className="cb-c-energy-chart__legend__items__item__figure"
            height={30}
            width={30}
          >
            <g>
              <line
                x1="0"
                y1="15"
                x2="30"
                y2="15"
                style={{
                  stroke: thresholdAlertThresholdLineColor,
                  strokeWidth: thresholdAlertThresholdLineWidth,
                  strokeDasharray: thresholdAlertThresholdLineDasharray
                }}
              />
            </g>
          </svg>
          <div className="cb-c-energy-chart__legend__items__item__label">
            Overnight threshold
          </div>
        </div>
      )}
      {props.showStoreClosedCheckbox && (
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <img
            src={storeClosedSvg}
            alt="Store Closed"
            height={30}
            width={30}
            style={{ display: 'inline-block', flexShrink: 0 }}
          />
          <Checkbox
            name="storeClosedToggle"
            label="Store Closed"
            checked={props.showStoreClosedOverlay}
            onChange={(checked) => props.callbackFromParent(checked)}
          />
        </div>
      )}
    </div>
  </div>
);

EnergyChartLegend.propTypes = {
  hasBaseline: PropTypes.bool,
  showStoreClosedCheckbox: PropTypes.bool,
  showStoreClosedOverlay: PropTypes.bool,
  callbackFromParent: PropTypes.func,
  actualsSeriesLabel: PropTypes.string.isRequired,
  hasAlerts: PropTypes.bool
};

EnergyChartLegend.defaultProps = {
  hasBaseline: true,
  showStoreClosedCheckbox: true,
  showStoreClosedOverlay: false
};

export default EnergyChartLegend;
